import { ValueToFormatedCurrencyBaseValueConverter } from 'General/Resources/ValueConverters/ValueToFormatedCurrencyBase';
export class ValueToFormatedCurrencyValueConverter extends ValueToFormatedCurrencyBaseValueConverter {

}